var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridgeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#3E7AF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8999 15.3V8.65C17.8999 7.88 17.2699 7.25 16.4999 7.25H12.6499",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8999 20.25C19.2806 20.25 20.3999 19.1307 20.3999 17.75C20.3999 16.3693 19.2806 15.25 17.8999 15.25C16.5192 15.25 15.3999 16.3693 15.3999 17.75C15.3999 19.1307 16.5192 20.25 17.8999 20.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1001 9.69995V16.35C7.1001 17.12 7.7301 17.75 8.5001 17.75H12.3501",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1001 9.75C8.48081 9.75 9.6001 8.63071 9.6001 7.25C9.6001 5.86929 8.48081 4.75 7.1001 4.75C5.71939 4.75 4.6001 5.86929 4.6001 7.25C4.6001 8.63071 5.71939 9.75 7.1001 9.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4581 9.00281V5.48418C14.4581 5.01393 13.9135 4.75309 13.5471 5.04783L11.3794 6.79143C11.1023 7.01434 11.1004 7.43574 11.3756 7.66106L13.5433 9.43608C13.9089 9.73546 14.4581 9.47535 14.4581 9.00281Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5413 19.4193V16.0667C10.5413 15.5629 11.1248 15.2834 11.5174 15.5992L13.5828 17.2605C13.8797 17.4994 13.8817 17.9509 13.5869 18.1923L11.5215 19.8836C11.1297 20.2043 10.5413 19.9256 10.5413 19.4193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeActive);
export default __webpack_public_path__ + "static/media/bridge_active.7570e2b3b651ba1efbd44d492e958a0c.svg";
export { ForwardRef as ReactComponent };